module.exports = __webpack_public_path__ + "media/PokeVue .474601e2.mp4";